import axiosClient from '../axiosClient';
import { CustomerAccountManagementEndpoints } from '../endpoints/customerAccountManagement';
import { IPage } from '../../types/store';

export interface IUserType {
  usertyp_pkid: number;
  usertyp_name: string;
  usertyp_isactive: boolean;
}

export interface ICustomerAccount {
  user_pkid: number;
  user_fname: string;
  user_lname: string;
  user_email: string;
  user_phone: string;
  userType: IUserType;
}

export interface ISearchCustomerAccountsResponse {
  content: ICustomerAccount[];
  page: IPage;
}

export interface IStandardResponse {
  status: boolean;
  message: string;
}

export interface ITemporaryPasswordResponse {
  temporary_password: string;
}

export const CustomerAccountManagementService = {
  async searchAccounts(
    page: number = 0,
    size: number = 20,
    search?: string,
  ): Promise<ISearchCustomerAccountsResponse> {
    const res = await axiosClient.get<ISearchCustomerAccountsResponse>(
      CustomerAccountManagementEndpoints.SEARCH,
      { params: { page, size, ...(search ? { search } : {}) } },
    );
    return res.data;
  },

  async lookupByPhone(phone: string): Promise<ICustomerAccount> {
    const res = await axiosClient.get<ICustomerAccount>(CustomerAccountManagementEndpoints.LOOKUP, {
      params: { phone },
    });
    return res.data;
  },

  async getUserTypes(): Promise<IUserType[]> {
    const res = await axiosClient.get<IUserType[]>(CustomerAccountManagementEndpoints.USER_TYPES);
    return res.data;
  },

  async updateUserType(id: number, usertypPkid: number): Promise<IStandardResponse> {
    const url = CustomerAccountManagementEndpoints.UPDATE_USER_TYPE.replace(':id', id.toString());
    const res = await axiosClient.patch<IStandardResponse>(url, { usertyp_pkid: usertypPkid });
    return res.data;
  },

  async resetPassword(id: number): Promise<ITemporaryPasswordResponse> {
    const url = CustomerAccountManagementEndpoints.RESET_PASSWORD.replace(':id', id.toString());
    const res = await axiosClient.post<ITemporaryPasswordResponse>(url);
    return res.data;
  },
};
